import Backdrop from "@material-ui/core/Backdrop";
import Fade from "@material-ui/core/Fade";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import NativeSelect from "@material-ui/core/NativeSelect";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Checkbox from "@material-ui/core/Checkbox";
import Modal from "@material-ui/core/Modal";
import React, { useState } from "react";
import { useStylesWellcome } from "./style";
import { withTranslation } from "react-i18next";

const Caption = (props) => {
  const classes = useStylesWellcome();
  const { openModal, handleCloseModal, setLanguageLocal, Language, t } = props;
  const [state, setState] = useState({ checked: false });
  const handleChange = (event) => {
    setState({ ...state, [event.target.name]: event.target.checked });
  };

  return (
    <Modal
      aria-labelledby="transition-modal-title"
      aria-describedby="transition-modal-description"
      className={classes.modal}
      open={openModal}
      closeAfterTransition
      BackdropComponent={Backdrop}
      BackdropProps={{
        timeout: 500,
      }}
    >
      <Fade in={openModal}>
        <div className={`${classes.paperWelcome} ${"modalBg"}`}>
          <div className="modal_languages">
            <div className="lang_show">
              <div className="desktop_show">
                <FormControl fullWidth className={classes.formControl}>
                  <Select
                    value={Language}
                    onChange={(e) => setLanguageLocal(e.target.value)}
                    MenuProps={{
                      anchorOrigin: {
                        vertical: "bottom",
                        horizontal: "left",
                      },
                      getContentAnchorEl: null,
                    }}
                  >
                    <MenuItem value="english">🇺🇸 English</MenuItem>
                    <MenuItem value="korean">🇰🇷 한국어</MenuItem>
                    <MenuItem value="chinese_simplified">🇨🇳 中文</MenuItem>
                  </Select>
                </FormControl>
              </div>
              <div className="mobile_show">
                <FormControl fullWidth className={classes.formControl}>
                  <NativeSelect
                    value={Language}
                    onChange={(e) => setLanguageLocal(e.target.value)}
                  >
                    <option value="english">🇺🇸 English</option>
                    <option value="korean">🇰🇷 한국어</option>
                    <option value="chinese_simplified">🇨🇳 中文</option>
                  </NativeSelect>
                </FormControl>
              </div>
            </div>
          </div>
          <div className="about_wallet_wapper">
            <div className="about_wallet">
              <h4>{t("About_Wallet")}</h4>
              <ul>
                <li>{t("About_Wallet_LineOne")}</li>
                <li>{t("About_Wallet_LineTwo")}</li>
                <li>{t("About_Wallet_LineThree")}</li>
              </ul>
              <h4>{t("Disclaimer")}</h4>
              <ul>
                <li>{t("Disclaimer_LineOne")}</li>
                <li>{t("Disclaimer_LineTwo")}</li>
                <li>{t("Disclaimer_LineThree")}</li>
                <li>{t("Disclaimer_LineFour")}</li>
              </ul>
              <h4>{t("Important_Notice")}</h4>
              <ul>
                <li>{t("Important_Notice_LineOne")}</li>
                <li>{t("Important_Notice_LineTwo")}</li>
                <li>{t("Important_Notice_LineThree")}</li>
              </ul>
              <div className="agree_with">
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={state.checked}
                      onChange={handleChange}
                      name="checked"
                      color="primary"
                    />
                  }
                  label={t("I_agree")}
                />
              </div>
              <div className="accept_btn">
                <button
                  className="btn btn-default senderBtn"
                  disabled={!state.checked}
                  onClick={() => handleCloseModal()}
                >
                  {t("Accept")}
                </button>
              </div>
            </div>
          </div>
        </div>
      </Fade>
    </Modal>
  );
};

export default withTranslation()(Caption);
